export default "__VITE_ASSET__Dca6_vUc__"